'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reduce2 = require('./internal/_reduce');

var _reduce3 = _interopRequireDefault(_reduce2);

var _curry = require('./curry');

var _curry2 = _interopRequireDefault(_curry);

var _immutable = require('immutable');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function indexBy(keyMapper, subject) {
  return (0, _reduce3.default)(_immutable.Iterable.isOrdered(subject) || !_immutable.Iterable.isIterable(subject) ? (0, _immutable.OrderedMap)() : (0, _immutable.Map)(), function (acc, v, k) {
    return acc.set(keyMapper(v, k, subject), v);
  }, subject);
}

/**
 * Create a Map, or OrderedMap from `subject` with a key for each item
 * returned by `keyMapper`.
 *
 * @example
 * indexBy(get('id'), List.of({id: 123}, {id: 456}))
 * // returns Map { 123: {id: 123}, 456: {id: 456} }
 *
 * @param  {Function} keyMapper generates keys for each item
 * @param  {Iterable} subject to index
 * @return {KeyedIterable}
 */
exports.default = (0, _curry2.default)(indexBy);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/transmute/static-2.3/indexBy.js
// module id = 358
// module chunks = 0 1